//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';

// Return the currently selected catalog, or the first available
// If there are none available, this will return undefined
// TODO: If it exists, use the catalog saved in user settings by default
export const getSelectedCatalog = createSelector(
  (state: ICuralateStore) => state.instagram.shops.catalogs,
  (state: ICuralateStore) =>
    state.instagram.shops.productSearchModal.selectedCatalog,
  (allCatalogs, selectedCatalog) => {
    return selectedCatalog ?? allCatalogs[0];
  },
);

export const getSelectedCatalogId = createSelector(
  getSelectedCatalog,
  (selectedCatalog) => {
    return selectedCatalog?.catalogId;
  },
);

export const getNewCatalogSelection = createSelector(
  (state: ICuralateStore, catalogId: string) => catalogId,
  (state: ICuralateStore) => state.instagram.shops.catalogs,
  (catalogId, catalogs) => {
    return catalogs.find((catalog) => catalog.catalogId === catalogId);
  },
);
